export default __webpack_public_path__ + "static/media/howto_4.1e561c3e.png";